<template>
  <div>
    <div class="structured-top text-center">
      <Spinner :showAfter="0" v-if="!isError && !paymentFailed" />
      <div v-if="!isSuccess && !isError && !paymentFailed">
        <img src="@/assets/img/purchase-in-process.png" alt="Purchase in process" />
        <h1 class="mt-2" v-html="$t('purchaseConfirmation.inProcess')" />
        <p class="mt-4">{{ $t('purchaseConfirmation.inProcess2') }}</p>
      </div>
      <div v-else-if="isSuccess">
        <img src="@/assets/img/purchase-successful.png" alt="Purchase successful" />
        <h1 class="mt-2" v-html="$t('purchaseConfirmation.success')" />
        <p class="mt-4">{{ $t('purchaseConfirmation.redirectingIn') }} {{ countdown }}</p>
      </div>
      <div v-else-if="paymentFailed">
        <img src="@/assets/img/purchase-error.png" alt="Purchase error" />
        <h1 class="mt-2" v-html="$t('purchaseConfirmation.failure')" />
        <p class="mt-4">{{ $t('purchaseConfirmation.redirectingIn') }} {{ countdown }}</p>
      </div>
      <div v-else-if="isError">
        <img src="@/assets/img/purchase-error.png" alt="Purchase error" />
        <h1 class="mt-2" v-html="$t('purchaseConfirmation.error')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Spinner from '@/components/Spinner.vue';

export default {
  name: 'PurchaseConfirmation',
  components: { Spinner },
  data: () => ({
    sessionReference: '',
    paymentReference: '',
    paymentFailed: false,
    isSuccess: false,
    isError: false,
    countdown: 5,
    countdownTimerId: 0,
    product: null,
  }),
  computed: {
    ...mapState('purchase', ['productToBuy']),
  },
  created() {
    const { order_reference, payment_reference } = this.$route.query || {};
    this.sessionReference = order_reference || '';
    this.paymentReference = payment_reference || '';

    if (this.productToBuy && this.productToBuy.id) {
      this.getProductById(this.productToBuy.id)
        .then((product) => this.product = product);
    }

    this.validate();
  },
  beforeUnmount() {
    if (this.countdownTimerId) {
      clearInterval(this.countdownTimerId);
    }
  },
  methods: {
    ...mapActions('product', ['getProductById']),
    async validate() {
      if (!this.sessionReference || !this.paymentReference) {
        this.isError = true;
        return;
      }

      try {
        const api = this.$store.getters.api;
        const { data } = await api.post('/purchase/validate', {
          sessionReference: this.sessionReference,
          paymentReference: this.paymentReference,
        });

        const status = (data && (data.status || data.result || data.state)) || '';
        if (String(status).toLowerCase() === 'settled') {
          this.isSuccess = true;
          this.paymentFailed = false;
          this.isError = false;
          await this.startCountdown();
          this.redirectToHistory();
        } else {
          // treat as a failed payment. can attempt again
          this.isSuccess = false;
          this.paymentFailed = true;
          this.isError = false;
          await this.startCountdown();
          this.redirectToPurchase();
        }
      } catch (e) {
        // treat as something went wrong. should not attempt again
        this.isSuccess = false;
        this.paymentFailed = false;
        this.isError = true;
      }
    },
    startCountdown() {
      this.countdown = 5;
      return new Promise((resolve) => {
        this.countdownTimerId = setInterval(() => {
          if (this.countdown > 1) {
            this.countdown -= 1;
          } else {
            clearInterval(this.countdownTimerId);
            resolve();
          }
        }, 1000);
      });
    },
    redirectToHistory() {
      const name = `purchaseHistory-${this.$i18n.locale}`;
      const query = { lang: this.$i18n.locale };
      const productCode = (this.product && this.product.productCode) || (this.productToBuy && this.productToBuy.productCode);

      if (productCode) {
        query.product = productCode;
      }

      this.$router.push({ name, params: { lang: this.$i18n.locale }, query });
    },
    redirectToPurchase() {
      const name = `purchase-${this.$i18n.locale}`;
      // Use replace to avoid leaving a broken confirmation page in history
      this.$router.replace({ name, params: { lang: this.$i18n.locale }, query: { fail: 1 } });
    },
  },
};
</script>
